// Constants
// Actions
import { CancelTrackedInteractionAction, CompleteTrackedInteractionAction, StartTrackedInteractionAction, ViewRenderAction } from "@ms/planner-actions/lib/local/performanceCollection/PerformanceCollectionAction";
import { MarkerTag } from "@ms/uno-telemetry/lib/local/performance/constants/PerformanceMarkerConstants";
export class PerformanceCollectionModule {
    setViewRenderState(viewId, state, extraData) {
        this.dispatcher.dispatchActionAsync(new ViewRenderAction(viewId, state, extraData));
    }
    startTrackedInteraction(interactionId, startTime, targetViewId, entryPoint, extraData) {
        this.dispatcher.dispatchActionAsync(new StartTrackedInteractionAction(interactionId.name, startTime, targetViewId, interactionId.key, entryPoint, extraData));
    }
    settleTrackedInteraction(targetViewId, interaction) {
        this.logInteraction(interaction, "settled");
        this.dispatcher.dispatchActionAsync(new CompleteTrackedInteractionAction(targetViewId, interaction.name));
    }
    abandonTrackedInteraction(interaction) {
        this.logInteraction(interaction, "abandoned");
    }
    cancelTrackedInteractions(targetViewId, pending) {
        for (const interaction of pending){
            this.logInteraction(interaction, "abandoned");
        }
        this.dispatcher.dispatchActionAsync(new CancelTrackedInteractionAction(targetViewId));
    }
    /**
     * Emit one measurement. Private so a duration can only be recorded as part of ending an interaction,
     * never for one that is still in flight.
     */ logInteraction(interaction, endMode) {
        const duration = performance.now() - interaction.startTime;
        // Log as performance mark (flows through existing telemetry pipeline)
        // Target thresholds (metTarget) are computed in Kusto, not client-side
        this.performanceMarker.mark(MarkerTag.UserInteraction, {
            ...interaction.extraData,
            entryPoint: interaction.entryPoint,
            name: interaction.name,
            duration: String(Math.round(duration)),
            endMode
        });
    }
    constructor(dispatcher, performanceMarker){
        this.dispatcher = dispatcher;
        this.performanceMarker = performanceMarker;
    }
}
